import React from 'react'

export interface IconExternalLinkTNProps {
    title?: string
    stroke?: string
}

export const IconExternalLinkTN: React.FC<IconExternalLinkTNProps> = ({
    title,
    stroke = '#A8A8A8',
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
    >
        <title>{title || 'Link to external icon'}</title>
        <path
            d="M11.25 4.25L11.25 0.75M11.25 0.75H7.75M11.25 0.75L6.58333 5.41667M4.83333 1.91667H3.55C2.56991 1.91667 2.07986 1.91667 1.70552 2.10741C1.37623 2.27518 1.10852 2.5429 0.940739 2.87218C0.75 3.24653 0.75 3.73657 0.75 4.71667V8.45C0.75 9.43009 0.75 9.92014 0.940739 10.2945C1.10852 10.6238 1.37623 10.8915 1.70552 11.0593C2.07986 11.25 2.56991 11.25 3.55 11.25H7.28333C8.26342 11.25 8.75347 11.25 9.12782 11.0593C9.4571 10.8915 9.72482 10.6238 9.89259 10.2945C10.0833 9.92014 10.0833 9.43009 10.0833 8.45V7.16667"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
